import i18next from 'i18next';

export const errorOnSendingOrder = async (payload, reducers, data) => {
  const { placeId, pointId, userId } = data;
  const { orderDispatch, notificationDispatch } = reducers;
  const { orderId } = payload;

  await orderDispatch({
    type: 'ORDER_CONFIRM_ACTIVE_NOT_RECEIVED',
    payload: {
      placeId,
      orderId,
      pointId,
      userId,
    },
  });
  const message = i18next.t('orders.NOTIFICATIONS.error_on_sending_order');
  const date = new Date().getTime();
  const newNotification = new CustomEvent('Notification', {
    detail: { message, type: 'danger', orderId, date },
  });
  window.dispatchEvent(newNotification);
  notificationDispatch({
    type: 'UPDATE_NOTIFICATION',
    payload: {
      notificationId: orderId,
      message,
      placeId,
      pointId,
      type: 'danger',
      date,
    },
  });
};
